import { useTranslation } from 'react-i18next';
import { SearchableSelect } from '~/components/ui/inputs/SearchableSelect';
import { useGetTransportVehicles } from '~/api/facility';
import type { BuyListLocationsQuery } from '~/graphql/graphql';
import { locationPickerLabel } from '~/pages/buy-lists/lib/locationLabel';
import { transportVehicleOptions } from '~/utils/vehicleGroups';

export type PickableBuyListLocation =
  BuyListLocationsQuery['buyListLocations'][number];

type LocationAndVehicleSelectsProps = {
  locations: PickableBuyListLocation[];
  locationId: string | null;
  transportVehicleId: string | null;
  onLocationChange: (locationId: string) => void;
  onTransportVehicleChange: (transportVehicleId: string) => void;
  locationTestId: string;
  vehicleTestId: string;
};

export function LocationAndVehicleSelects({
  locations,
  locationId,
  transportVehicleId,
  onLocationChange,
  onTransportVehicleChange,
  locationTestId,
  vehicleTestId,
}: Readonly<LocationAndVehicleSelectsProps>) {
  const { t } = useTranslation('inventory');

  const locationOptions = locations.map((location) => ({
    value: location.id,
    label: locationPickerLabel(location),
  }));

  const { data: vehiclesData } = useGetTransportVehicles();
  const vehicleOptions = transportVehicleOptions(
    (vehiclesData && vehiclesData.transportVehicles) ?? []
  );

  return (
    <>
      <div data-testid={locationTestId}>
        <SearchableSelect
          label={t('inventory.buy_list.location')}
          name="buy-list-location"
          value={locationId ?? undefined}
          options={locationOptions}
          onChange={(_name, value) => onLocationChange(value)}
        />
      </div>

      <div data-testid={vehicleTestId}>
        <SearchableSelect
          label={t('inventory.buy_list.vehicle')}
          name="buy-list-vehicle"
          value={transportVehicleId ?? undefined}
          options={vehicleOptions}
          onChange={(_name, value) => onTransportVehicleChange(value)}
        />
      </div>
    </>
  );
}
